import type { ReactElement } from "react";
import { useRouteError, useNavigate, isRouteErrorResponse } from "react-router";
import { useEffect, useState } from "react";
import ErrorFallback from "@/components/ErrorFallback";
import NotFoundFallback from "@/components/NotFoundFallback";
import { logClientError } from "@/utils/errorLogger";

const RouteErrorPage = (): ReactElement => {
  const error = useRouteError();
  const navigate = useNavigate();
  const [correlationId, setCorrelationId] = useState<string | null>(null);

  const isNotFound =
    isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (isNotFound) return;

    const err =
      error instanceof Error
        ? error
        : new Error(
            typeof error === "object" &&
              error &&
              "message" in error
              ? String((error as { message?: unknown }).message)
              : "Route error"
          );
    const { correlationId: id } = logClientError(err, {
      route:
        typeof window !== "undefined" ? window.location.pathname : undefined,
    });
    setCorrelationId(id);
  }, [error, isNotFound]);

  const handleRetry = (): void => {
    navigate(0);
  };
  const handleGoHome = (): void => {
    navigate("/");
  };

  if (isNotFound) {
    return <NotFoundFallback onGoHome={handleGoHome} />;
  }

  return (
    <ErrorFallback
      errorId={correlationId ?? undefined}
      onRetry={handleRetry}
      onGoHome={handleGoHome}
    />
  );
};

export default RouteErrorPage;
